import { createSlice } from '@reduxjs/toolkit';

const stepBuilderSlice = createSlice({
  name: 'stepBuilder',
  initialState: {
    current: 1,
    total: 3
  },
  reducers: {
    setTotal: (state, action) => {
      state.total = action.payload;
    },
    nextStep: (state) => {
      if (state.current < state.total) {
        state.current += 1;
      }
    },
    prevStep: (state) => {
      if (state.current > 1) {
        state.current -= 1;
      }
    },
    jumpToStep: (state, action) => {
      if (action.payload >= 1 && action.payload <= state.total) {
        state.current = action.payload;
      }
    },
    resetSteps: (state) => {
      state.current = 1;
    }
  }
});

export const { setTotal, nextStep, prevStep, jumpToStep, resetSteps } = stepBuilderSlice.actions;
export default stepBuilderSlice.reducer;